/*!
 Current file is based on ngToast (http://tamerayd.in/ngToast/) implementation and will be work derived from ngToast library release under the MIT license below:

 The MIT License (MIT)
 Copyright &copy; 2016 Tamer Aydin, http://tamerayd.in

 Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
 to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense,
 and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

var DateTime = require('../../utils/datetime');
//(function(window, angular) {
	'use strict';

	angular.module('appToast.provider').provider('appToast', appToastProvider);

	/** @ngInject */
	function appToastProvider() {
		var messages = [],
			messageStack = [];

		var defaults = {
			animation: false, 				// only if using ng-animate
			className: 'success',
			additionalClasses: null,
			dismissOnTimeout: true,
			timeout: 4000,
			dismissButton: false,
			bounce: false,
			dismissButtonHtml: '&times;',
			dismissOnClick: true,
			onDismiss: null,
			compileContent: false,
			combineDuplications: false,
			horizontalPosition: 'right', 	// right, center, left
			verticalPosition: 'bottom', 	// top, bottom,
			maxNumber: 0,
			newestOnTop: true,
			multiline: true,				// if multiline, cut after 110 chars
			showTimestamp: false
		};

		function Message(msg) {
			var id = Math.floor(Math.random()*1000);
			while (messages.indexOf(id) > -1) {
				id = Math.floor(Math.random()*1000);
			}

			this.id = id;
			this.count = 0;
			this.animation = defaults.animation;
			this.className = defaults.className;
			this.additionalClasses = defaults.additionalClasses;
			this.dismissOnTimeout = defaults.dismissOnTimeout;
			this.timeout = defaults.timeout;
			this.dismissButton = defaults.dismissButton;
			this.dismissButtonHtml = defaults.dismissButtonHtml;
			this.dismissOnClick = defaults.dismissOnClick;
			this.onDismiss = defaults.onDismiss;
			this.compileContent = defaults.compileContent;
			this.bounce = defaults.bounce;
			this.multiline = defaults.multiline;
			this.showTimestamp = defaults.showTimestamp;

			angular.extend(this, msg);

			if (typeof this === 'object' && this.multiline && this.content && this.content.length > 300) {
				this.content = this.content.substring(0, 300) + "...";
			}

			if (this.className === 'danger' || this.showTimestamp) {
				var dateTime = new Date();
				this.timestamp = dateTime.toLocaleDateString() + " " + DateTime.formattedNow();
			}
		}

		this.configure = function(config) {
			angular.extend(defaults, config);
		};

		this.$get = [function() {
			var _createWithClassName = function(className, msg) {
				msg = (typeof msg === 'object') ? msg : {content: msg};
				msg.className = className;

				return this.create(msg);
			};

			return {
				settings: defaults,
				messages: messages,
				dismiss: function(id) {
					if (id) {
						for (var i = messages.length - 1; i >= 0; i--) {
							if (messages[i].id === id) {
								messages.splice(i, 1);
								messageStack.splice(messageStack.indexOf(id), 1);
								return;
							}
						}

					} else {
						while(messages.length > 0) {
							messages.pop();
						}
						messageStack = [];
					}
				},
				create: function(msg) {
					msg = (typeof msg === 'object') ? msg : {content: msg};

					if (defaults.combineDuplications) {
						for (var i = messageStack.length - 1; i >= 0; i--) {
							var _msg = messages[i];
							var _className = msg.className || 'success';

							if (_msg.content === msg.content &&
								_msg.className === _className) {
								messages[i].count++;
								return;
							}
						}
					}

					if (defaults.maxNumber > 0 &&
						messageStack.length >= defaults.maxNumber) {
						this.dismiss(messageStack[0]);
					}

					var newMsg = new Message(msg);
					messages[defaults.newestOnTop ? 'unshift' : 'push'](newMsg);
					messageStack.push(newMsg.id);

					return newMsg.id;
				},
				success: function(msg) {
					return _createWithClassName.call(this, 'success', msg);
				},
				info: function(msg) {
					return _createWithClassName.call(this, 'info', msg);
				},
				warning: function(msg) {
					return _createWithClassName.call(this, 'warning', msg);
				},
				danger: function(msg) {
					return _createWithClassName.call(this, 'danger', msg);
				}
			};
		}];
	}

//})(window, window.angular);
